<template>
  <div>

    <!-- ══════════════════════════════════════════════════
         MODAL — Mover Batida de Turno
    ═══════════════════════════════════════════════════════ -->
    <div
      v-if="exibirModalMoverBatida"
      id="modalMoveTurn"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      :class="{'show': !hasJQuery}"
      :style="!hasJQuery ? 'display:block;background:rgba(0,0,0,0.5);' : null"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <i class="fas fa-random text-warning mr-2" /> Mover Batida de Turno
            </h5>
            <button
              type="button"
              class="close"
              aria-label="Fechar"
              @click="fecharModalMoverBatida"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div
            v-if="batidaParaMover"
            class="modal-body p-3"
          >
            <div class="alert alert-warning py-2 mb-3">
              <small class="text-muted d-block mb-1">Horário da batida</small>
              <strong>{{ formatHour(batidaParaMover) }}</strong>
            </div>
            <div class="form-group mb-0">
              <label>Nova data de turno <span class="text-danger">*</span></label>
              <input
                v-model="novaDataTurno"
                type="date"
                class="form-control"
              >
              <small class="text-muted">Selecione a data correta para o turno desta batida.</small>
            </div>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              @click="fecharModalMoverBatida"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              :disabled="!novaDataTurno"
              @click="moverBatidaDeTurno"
            >
              Confirmar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- ══════════════════════════════════════════════════
         MODAL — Ajuste de Desvio de Horário
    ═══════════════════════════════════════════════════════ -->
    <div
      v-if="exibirModalDesvio"
      id="modalDesvio"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      :class="{'show': !hasJQuery}"
      :style="!hasJQuery ? 'display:block;background:rgba(0,0,0,0.5);' : null"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <i class="fas fa-clock text-warning mr-2" /> Ajuste de Desvio de Horário
            </h5>
            <button
              type="button"
              class="close"
              aria-label="Fechar"
              @click="fecharModalDesvio"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div
            v-if="batidaDesvio"
            class="modal-body p-3"
          >
            <div
              class="d-flex mb-3"
              style="gap:0.5rem;"
            >
              <div class="alert alert-warning py-2 mb-0 flex-fill">
                <small class="text-muted d-block mb-1">Horário batido</small>
                <strong>{{ formatHour(batidaDesvio) }}</strong>
              </div>
              <div class="alert alert-secondary py-2 mb-0 flex-fill">
                <small class="text-muted d-block mb-1">Horário considerado</small>
                <strong>{{ consideredHour(batidaDesvio) || '—' }}</strong>
              </div>
            </div>

            <div class="form-group mb-3">
              <label>Ação <span class="text-danger">*</span></label>
              <div
                class="d-flex"
                style="gap:0.5rem;"
              >
                <button
                  type="button"
                  class="btn btn-sm flex-fill"
                  :class="acaoDesvio === 'approve' ? 'btn-success' : 'btn-outline-success'"
                  @click="acaoDesvio = 'approve'"
                >
                  <i class="fas fa-check mr-1" /> Aprovar
                </button>
                <button
                  type="button"
                  class="btn btn-sm flex-fill"
                  :class="acaoDesvio === 'reject' ? 'btn-danger' : 'btn-outline-danger'"
                  @click="acaoDesvio = 'reject'"
                >
                  <i class="fas fa-times mr-1" /> Rejeitar e corrigir
                </button>
              </div>
            </div>

            <template v-if="acaoDesvio === 'reject'">
              <div class="form-group mb-2">
                <label>Novo horário <span class="text-danger">*</span></label>

                <div
                  v-if="suggestionDesvio"
                  class="mb-2"
                >
                  <small class="text-muted">
                    Sugestão baseada na jornada
                    ({{ suggestionDesvio.punch_type === 'entry' ? 'entrada' : 'saída' }}
                    esperada: <strong>{{ suggestionDesvio.expected_time }}</strong>):
                  </small>
                  <br>
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-primary mt-1"
                    @click="novoHorarioDesvio = suggestionDesvio.suggested_time"
                  >
                    <i class="fas fa-magic mr-1" />
                    Usar {{ formatSuggestion(suggestionDesvio.suggested_time) }}
                  </button>
                </div>

                <div
                  v-if="loadingSuggestion"
                  class="mb-2"
                >
                  <small class="text-muted">
                    <i class="fas fa-spinner fa-spin mr-1" /> Buscando sugestão da jornada...
                  </small>
                </div>

                <input
                  v-model="novoHorarioDesvio"
                  type="datetime-local"
                  class="form-control"
                >
                <small class="text-muted">Horário que será salvo no ponto e registrado como ajuste.</small>
              </div>

              <div class="form-group mb-0">
                <label>Justificativa <span class="text-danger">*</span></label>
                <textarea
                  v-model="justificativaDesvio"
                  class="form-control"
                  rows="3"
                  placeholder="Descreva o motivo do ajuste..."
                  maxlength="500"
                />
                <small class="text-muted">{{ justificativaDesvio.length }}/500</small>
              </div>
            </template>

            <div
              v-if="acaoDesvio === 'approve'"
              class="alert alert-info py-2 mb-0 mt-2"
            >
              <i class="fas fa-info-circle mr-1" />
              O horário original será mantido e o desvio marcado como revisado.
            </div>

            <!-- Histórico de decisões desta batida -->
            <div class="mt-3">
              <label class="d-block mb-1">
                <i class="fas fa-history mr-1" /> Histórico de decisões
              </label>
              <div
                v-if="loadingHistoricoDesvio"
                class="text-muted"
              >
                <small><i class="fas fa-spinner fa-spin mr-1" /> Carregando histórico...</small>
              </div>
              <div
                v-else-if="!historicoDesvio.length"
                class="text-muted"
              >
                <small>Nenhuma decisão registrada ainda.</small>
              </div>
              <ul
                v-else
                class="list-unstyled mb-0"
                style="max-height:160px;overflow-y:auto;"
              >
                <li
                  v-for="h in historicoDesvio"
                  :key="h.id"
                  class="border rounded p-2 mb-1"
                  style="font-size:0.8rem;"
                >
                  <span
                    class="badge"
                    :class="h.decision === 'approved' ? 'badge-success' : 'badge-danger'"
                  >
                    {{ h.decision === 'approved' ? 'Aprovado' : 'Rejeitado' }}
                  </span>
                  <span class="ml-1">{{ formatHistoryDate(h.reviewed_at) }}</span>
                  <span
                    v-if="h.reviewer"
                    class="text-muted ml-1"
                  >por {{ h.reviewer.name }}</span>
                  <div
                    v-if="h.decision === 'rejected'"
                    class="text-muted"
                  >
                    {{ formatHistoryDate(h.original_punched_at) }}
                    <i class="fas fa-arrow-right mx-1" />
                    {{ formatHistoryDate(h.adjusted_punched_at) }}
                  </div>
                  <div
                    v-if="h.justification"
                    class="text-muted font-italic"
                  >
                    {{ h.justification }}
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              :disabled="loadingDesvio"
              @click="fecharModalDesvio"
            >Cancelar</button>
            <button
              type="button"
              class="btn btn-primary"
              :disabled="!acaoDesvio || loadingDesvio"
              @click="confirmarAcaoDesvio"
            >
              <span v-if="loadingDesvio"><i class="fas fa-spinner fa-spin mr-1" /> Salvando...</span>
              <span v-else>Confirmar</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- ══════════════════════════════════════════════════
         CARD PRINCIPAL
    ═══════════════════════════════════════════════════════ -->
    <div class="card">
      <div class="card-header animated fadeInRightBig">
        <div class="card-title">
          Marcações da Equipe
        </div>
      </div>
      <div class="card-body">

        <!-- Filtros -->
        <div class="row">
          <div class="col-12 col-md-4 mb-3">
            <div class="form-group">
              <label>Usuário</label>
              <v-select
                v-model="search.user_id"
                :options="users"
                label="name"
                :reduce="u => u.id"
                placeholder="Selecione um usuário"
                clearable
              />
            </div>
          </div>
          <div class="col-12 col-md-3 mb-3">
            <div class="form-group">
              <label>Ano</label>
              <v-select
                v-model="search.year"
                :options="yearOptions"
                label="label"
                :reduce="o => o.value"
                placeholder="Selecione o ano"
                clearable
              />
            </div>
          </div>
          <div class="col-12 col-md-3 mb-3">
            <div class="form-group">
              <label>Mês</label>
              <v-select
                v-model="search.month"
                :options="monthOptions"
                label="label"
                :reduce="o => o.value"
                placeholder="Selecione o mês"
                clearable
              />
            </div>
          </div>
          <div class="col-12 col-md-2 mb-3">
            <div class="form-group">
              <label>Ação</label>
              <button
                class="btn btn-block btn-info w-100"
                :disabled="!search.user_id || !search.year || !search.month"
                @click="searchChecks"
              >
                Buscar
              </button>
            </div>
          </div>
        </div>

        <div
          v-if="search.user_id && hasSearched"
          class="row mb-2"
        >
          <div class="col-12">
            <div
              v-if="!hasWorktime"
              class="alert alert-warning mb-0 schedule-banner"
            >
              <strong>Usuário sem jornada cadastrada.</strong>
              Cadastre uma jornada para exibir os horários esperados de entrada e saída.
            </div>
            <div
              v-else
              class="alert alert-primary mb-0 schedule-banner"
            >
              <strong>Jornada:</strong> {{ worktimeLabel }}
              <span class="mx-2">|</span>
              <strong>Entrada:</strong> {{ formatScheduleClock(worktime && worktime.expected_entry_time) }}
              <span class="mx-2">|</span>
              <strong>Saída:</strong> {{ formatScheduleClock(worktime && worktime.expected_exit_time) }}
            </div>
          </div>
        </div>

        <div
          v-if="hasPendingDeviationInResults"
          class="alert pending-diff-notice mb-2"
          role="status"
        >
          <i
            class="fas fa-clock mr-1"
            aria-hidden="true"
          />
          Há batidas <strong>pendentes de aprovação</strong>. Enquanto não forem revisadas,
          os cálculos (horas trabalhadas e diferença) estão sendo feitos com base na
          <strong>hora considerada</strong> (horário previsto da jornada/escala).
          Ao <strong>aprovar</strong>, passa a valer a hora batida; ao <strong>rejeitar</strong>,
          a batida é ajustada para o horário previsto.
        </div>

        <!-- ══ TABELA DESKTOP ══════════════════════════════════ -->
        <div
          v-if="Array.isArray(checks) && checks.length > 0"
          class="row d-none d-md-block"
        >
          <div class="col-12">
            <div class="d-flex align-items-center justify-content-center mb-2 flex-wrap legend-bar">
              <span class="legend-item"><span class="legend-dot legend-blue" /> Solicitação</span>
              <span class="legend-item"><span class="legend-dot legend-green" /> Remoto</span>
              <span class="legend-item"><span class="legend-dot legend-purple" /> Manual</span>
              <span class="legend-item">
                <i
                  class="fas fa-clock"
                  style="color:#f6a609;font-size:0.85rem;"
                />
                Pendente de aprovação
              </span>
              <span class="legend-item">
                <i class="fas fa-exclamation-triangle text-danger" />
                Inconsistência (Fora da cerca / Foto não checada)
              </span>
            </div>

            <div
              class="table-responsive"
              style="max-height:600px;overflow-y:auto;"
            >
              <table class="table table-hover table-striped text-center">
                <thead>
                  <tr>
                    <th style="width:120px">
                      Data
                    </th>
                    <th
                      v-for="n in maxPunches"
                      :key="'th-' + n"
                      style="width:100px"
                    >
                      {{ n % 2 === 1 ? `Entrada ${Math.ceil(n / 2)}` : `Saída ${n / 2}` }}
                    </th>
                    <th style="width:110px">
                      Intervalo
                    </th>
                    <th style="width:180px">
                      Resultado
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(check, ci) in checks"
                    :key="'row-' + ci"
                  >
                    <td class="align-middle">
                      {{ getDateForRow(check) }}
                    </td>

                    <td
                      v-for="n in maxPunches"
                      :key="`p-${ci}-${n}`"
                      class="text-center align-middle"
                    >
                      <div
                        v-if="check.punches[n - 1]"
                        class="d-flex flex-column justify-content-center align-items-center"
                        style="gap:0.25rem;"
                      >
                        <button
                          class="btn btn-sm btn-outline-primary pin-button"
                          title="Exibir informações do ponto"
                          @click="openMapaModal(check.punches[n - 1])"
                        >
                          <i class="fas fa-map-pin" />
                        </button>

                        <span
                          class="time-info d-flex align-items-center"
                          style="gap:0.3rem;"
                          :class="getPunchColorClass(check.punches[n - 1])"
                        >
                          {{ formatHour(check.punches[n - 1]) }}
                          <i
                            v-if="hasInconsistency(check.punches[n - 1])"
                            class="fas fa-exclamation-triangle text-danger"
                            title="Alerta: Fora da cerca ou foto não checada"
                            style="font-size:0.8rem;"
                          />
                          <i
                            v-if="hasScheduleDeviation(check.punches[n - 1])"
                            class="fas fa-clock"
                            style="color:#f6a609;font-size:0.8rem;cursor:pointer;"
                            title="Pendente de aprovação — clique para revisar"
                            @click="abrirModalDesvio(check.punches[n - 1])"
                          />
                        </span>

                        <!-- Só enquanto pendente: aprovado/rejeitado já tem time_to_consider = horário efetivo (sem "previsto" a exibir). -->
                        <span
                          v-if="hasScheduleDeviation(check.punches[n - 1]) && consideredHour(check.punches[n - 1])"
                          class="considered-badge considered-pending"
                          title="Pendente — cálculo feito com base neste horário previsto"
                        >
                          <i class="fas fa-clock" /> previsto {{ consideredHour(check.punches[n - 1]) }}
                        </span>

                        <div
                          class="d-flex flex-wrap justify-content-center"
                          style="gap:0.25rem;"
                        >
                          <button
                            v-if="canMoveTurn"
                            class="btn btn-sm btn-outline-warning"
                            title="Mover turno"
                            @click="abrirModalMoverBatida(check.punches[n - 1])"
                          >
                            <i class="fas fa-random" /> Mover turno
                          </button>
                          <button
                            v-if="canReviewDeviation && hasScheduleDeviation(check.punches[n - 1])"
                            class="btn btn-sm btn-outline-warning"
                            title="Revisar pendência de aprovação"
                            @click="abrirModalDesvio(check.punches[n - 1])"
                          >
                            <i class="fas fa-clock" /> Revisar
                          </button>
                        </div>
                      </div>
                      <span
                        v-else
                        class="text-muted"
                      >-</span>
                    </td>

                    <td class="text-center">
                      <span
                        v-if="calcRestInterval(check)"
                        class="badge badge-info"
                      >{{ calcRestInterval(check) }}</span>
                      <span
                        v-else
                        class="text-muted"
                      >-</span>
                    </td>
                    <td class="text-left align-middle">
                      <div class="result-cell">
                        <div class="result-row">
                          <span class="result-label">Trabalhadas</span>
                          <span class="result-value">{{ dayWorked(check) }}</span>
                        </div>
                        <div class="result-row">
                          <span class="result-label">Previstas</span>
                          <span class="result-value">{{ dayExpected(check) }}</span>
                        </div>
                        <div
                          class="result-row"
                          :class="{ 'result-na-pending': hasUnauthorized(check) }"
                        >
                          <span class="result-label">
                             Extra não autorizada
                            <i
                              v-if="hasUnauthorized(check)"
                              class="fas fa-clock mr-1"
                            />N.A.
                          </span>
                          <span class="result-value">{{ dayUnauthorized(check) }}</span>
                        </div>
                        <div class="result-row result-saldo">
                          <span class="result-label">Saldo</span>
                          <span class="result-value">
                            <span
                              v-if="check.diff"
                              class="badge"
                              :class="getDifferenceClass(check.diff)"
                            >{{ check.diff }}</span>
                            <span
                              v-else
                              class="text-muted"
                            >00:00:00</span>
                          </span>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- Sem resultados desktop -->
        <div
          v-if="Array.isArray(checks) && checks.length === 0"
          class="row d-none d-md-block"
        >
          <div class="col-12">
            <div class="alert alert-info text-center mt-2">
              Nenhum registro no período para o usuário selecionado.
            </div>
          </div>
        </div>

        <!-- ══ CARDS MOBILE ════════════════════════════════════ -->
        <div class="row d-md-none">
          <div class="col-12">
            <div class="d-flex align-items-center justify-content-center mb-2 flex-wrap legend-bar">
              <span class="legend-item"><span class="legend-dot legend-blue" /> Solicitação</span>
              <span class="legend-item"><span class="legend-dot legend-green" /> Remoto</span>
              <span class="legend-item"><span class="legend-dot legend-purple" /> Manual</span>
              <span class="legend-item">
                <i
                  class="fas fa-clock"
                  style="color:#f6a609;font-size:0.85rem;"
                />
                Pendente de aprovação
              </span>
              <span class="legend-item">
                <i class="fas fa-exclamation-triangle text-danger" />
                Alerta (Fora da cerca / Foto não checada)
              </span>
            </div>

            <div class="row">
              <div
                v-for="(check, ci) in checks"
                v-if="isValidMobileCheck(check)"
                :key="'mobile-' + ci"
                class="col-12 mb-3"
              >
                <div class="card h-100 check-card">
                  <div class="card-header bg-light">
                    <h6 class="card-title mb-0 text-primary">
                      <i class="fas fa-calendar-day mr-2" />{{ getDateForRow(check) }}
                    </h6>
                  </div>
                  <div class="card-body p-3">
                    <div
                      v-for="(punch, pi) in (check.punches || [])"
                      v-if="punch"
                      :key="'punch-' + pi"
                      class="row mb-2"
                    >
                      <div class="col-4">
                        <strong class="text-muted">
                          {{ pi % 2 === 0 ? `Entrada ${Math.floor(pi / 2) + 1}` : `Saída ${Math.ceil((pi + 1) / 2)}` }}
                        </strong>
                      </div>
                      <div
                        class="col-8 d-flex align-items-center flex-wrap"
                        style="gap:0.4rem;"
                      >
                        <button
                          class="btn btn-sm btn-outline-primary btn-pin"
                          @click="openMapaModal(punch)"
                        >
                          <i class="fas fa-map-pin" />
                        </button>
                        <span :class="['time-text', getPunchColorClass(punch)]">{{ format(punch.created_at) }}</span>
                        <i
                          v-if="hasInconsistency(punch)"
                          class="fas fa-exclamation-triangle text-danger"
                          title="Fora da cerca ou foto não checada"
                        />
                        <i
                          v-if="hasScheduleDeviation(punch)"
                          class="fas fa-clock"
                          style="color:#f6a609;cursor:pointer;"
                          title="Pendente de aprovação — toque para revisar"
                          @click="abrirModalDesvio(punch)"
                        />
                        <button
                          v-if="canReviewDeviation && hasScheduleDeviation(punch)"
                          class="btn btn-sm btn-outline-warning"
                          @click="abrirModalDesvio(punch)"
                        >
                          <i class="fas fa-clock" />
                        </button>
                        <!-- Só enquanto pendente: aprovado/rejeitado já tem time_to_consider = horário efetivo. -->
                        <span
                          v-if="hasScheduleDeviation(punch) && consideredHour(punch)"
                          class="considered-badge w-100 considered-pending"
                          title="Pendente — cálculo feito com base neste horário previsto"
                        >
                          <i class="fas fa-clock" /> previsto {{ consideredHour(punch) }}
                        </span>
                      </div>
                    </div>

                    <!-- Intervalo mobile -->
                    <div
                      v-if="calcRestInterval(check)"
                      class="row mt-1"
                    >
                      <div class="col-6">
                        <strong class="text-muted">Intervalo:</strong>
                      </div>
                      <div class="col-6 text-right">
                        <span class="badge badge-info">{{ calcRestInterval(check) }}</span>
                      </div>
                    </div>

                    <div class="row mt-2">
                      <div class="col-6">
                        <strong class="text-muted">Horas trabalhadas:</strong>
                      </div>
                      <div class="col-6 text-right">
                        <span class="badge badge-info">{{ dayWorked(check) }}</span>
                      </div>
                    </div>
                    <div class="row mt-1">
                      <div class="col-6">
                        <strong class="text-muted">Horas previstas:</strong>
                      </div>
                      <div class="col-6 text-right">
                        <span class="badge badge-light border">{{ dayExpected(check) }}</span>
                      </div>
                    </div>
                    <div class="row mt-1">
                      <div class="col-6">
                        <strong class="text-muted">
                          <i
                            v-if="hasUnauthorized(check)"
                            class="fas fa-clock mr-1"
                            style="color:#f6a609;"
                          />
                          Extra não autorizada:
                        </strong>
                      </div>
                      <div class="col-6 text-right">
                        <span
                          class="badge"
                          :class="hasUnauthorized(check) ? 'badge-warning' : 'badge-light border'"
                        >
                          {{ dayUnauthorized(check) }}
                        </span>
                      </div>
                    </div>
                    <div class="row mt-1">
                      <div class="col-6">
                        <strong class="text-muted">Saldo:</strong>
                      </div>
                      <div class="col-6 text-right">
                        <span
                          v-if="check.diff"
                          class="badge"
                          :class="getDifferenceClass(check.diff)"
                        >{{ check.diff }}</span>
                        <span
                          v-else
                          class="text-muted"
                        >00:00:00</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                v-if="!hasValidMobileChecks()"
                class="col-12"
              >
                <div class="alert alert-info text-center">
                  <i class="fas fa-info-circle mr-2" /> Nenhum registro no período para o usuário selecionado.
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ══ MODAL MAPA ══════════════════════════════════════ -->
        <div
          id="modalMapa"
          class="modal fade"
          tabindex="-1"
          role="dialog"
          aria-labelledby="modalMapaTitle"
          aria-hidden="true"
        >
          <div
            class="modal-dialog modal-xl modal-dialog-centered modal-responsive"
            role="document"
          >
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">
                  Mapa da marcação do ponto remoto
                </h5>
              </div>

              <div
                v-if="checkToMap"
                class="modal-body p-2 p-md-3"
              >
                <div
                  v-show="hasMapCoords"
                  class="row mb-3"
                >
                  <div class="col-12">
                    <div
                      ref="mapEl"
                      class="check-map-container"
                    />
                  </div>
                </div>

                <!-- Mobile -->
                <div class="d-md-none">
                  <div class="card mb-3">
                    <div class="card-header bg-light">
                      <h6 class="card-title mb-0">
                        <i class="fas fa-info-circle mr-2" /> Informações do Ponto
                      </h6>
                    </div>
                    <div class="card-body p-3">
                      <div class="row mb-2">
                        <div class="col-5">
                          <strong class="text-muted">Data</strong>
                        </div>
                        <div class="col-7">
                          <span>{{ checkToMap.created_at_f }}</span>
                        </div>
                      </div>
                      <div class="row mb-2">
                        <div class="col-5">
                          <strong class="text-muted">Endereço</strong>
                        </div>
                        <div class="col-7">
                          <span class="text-break">{{ formatted_address }}</span>
                        </div>
                      </div>
                      <div class="row mb-2">
                        <div class="col-5">
                          <strong class="text-muted">Foto</strong>
                        </div>
                        <div class="col-7">
                          <button
                            v-if="checkToMap.images && checkToMap.images[0]"
                            type="button"
                            class="btn btn-sm btn-outline-secondary"
                            @click="openImage(checkToMap.images[0].photo_check_url)"
                          >
                            <i class="fas fa-images mr-1" /> Ver foto
                          </button>
                          <span
                            v-else
                            class="text-muted"
                          >Sem foto</span>
                        </div>
                      </div>
                      <div class="row mb-2">
                        <div class="col-5">
                          <strong class="text-muted">Face</strong>
                        </div>
                        <div class="col-7">
                          <span
                            class="badge"
                            :class="checkToMap.check_face ? 'badge-success' : 'badge-danger'"
                          >
                            {{ checkToMap.check_face ? 'Verificada' : 'Não verificada' }}
                          </span>
                        </div>
                      </div>
                      <div class="row mb-2">
                        <div class="col-5">
                          <strong class="text-muted">Ponto fora da cerca</strong>
                        </div>
                        <div class="col-7">
                          <span
                            class="badge"
                            :class="isOutsideGeofence(checkToMap) ? 'badge-danger' : 'badge-success'"
                          >
                            {{ getGeofenceLabel(checkToMap) }}
                          </span>
                        </div>
                      </div>
                      <hr class="my-3">
                      <div class="row">
                        <div class="col-12">
                          <button
                            type="button"
                            class="btn btn-outline-danger btn-block"
                            @click="confirmMapCheck"
                          >
                            <i class="far fa-trash-alt mr-1" /> Excluir Ponto
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Desktop -->
                <div class="d-none d-md-block">
                  <div class="table-container-scroll">
                    <table class="table table-hover table-sm">
                      <thead class="thead-light">
                        <tr>
                          <th>Data</th>
                          <th>Endereço</th>
                          <th>Foto</th>
                          <th>Face</th>
                          <th>Cerca</th>
                          <th>Ação</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{{ checkToMap.created_at_f }}</td>
                          <td class="text-break">
                            {{ formatted_address }}
                          </td>
                          <td>
                            <button
                              v-if="checkToMap.images && checkToMap.images[0]"
                              type="button"
                              class="btn btn-sm btn-outline-secondary"
                              @click="openImage(checkToMap.images[0].photo_check_url)"
                            >
                              <i class="fas fa-images" />
                            </button>
                            <span
                              v-else
                              class="text-muted"
                            >-</span>
                          </td>
                          <td class="text-center">
                            <span
                              class="badge"
                              :class="checkToMap.check_face ? 'badge-success' : 'badge-danger'"
                            >
                              {{ checkToMap.check_face ? 'Verificada' : 'Não verificada' }}
                            </span>
                          </td>
                          <td class="text-center">
                            <span
                              class="badge"
                              :class="isOutsideGeofence(checkToMap) ? 'badge-danger' : 'badge-success'"
                            >
                              {{ getGeofenceLabel(checkToMap) }}
                            </span>
                          </td>
                          <td>
                            <button
                              type="button"
                              class="btn btn-sm btn-outline-danger"
                              @click="confirmMapCheck"
                            >
                              <i class="far fa-trash-alt" />
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

export default {
  data() {
    return {
      checks: [],
      users: [],
      bank: null,
      wku: { hours: 8 },
      worktime: null,
      hasSearched: false,
      loaded: false,
      loading: false,
      errors: null,
      search: {
        year: null,
        month: null,
        user_id: null,
      },
      monthNames: [
        'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
        'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro',
      ],
      center: { lat: 0, lng: 0 },
      markerPosition: null,
      checkMap: null,
      checkMarker: null,
      location: null,
      latitude: null,
      longitude: null,
      formatted_address: '',
      isLoading: false,
      error: null,
      checkToMap: null,
      url: '',
      check_face: false,
      outside_geofence: false,
      exibirModalMoverBatida: false,
      batidaParaMover: null,
      novaDataTurno: '',
      exibirModalDesvio: false,
      batidaDesvio: null,
      acaoDesvio: null,
      novoHorarioDesvio: '',
      justificativaDesvio: '',
      loadingDesvio: false,
      suggestionDesvio: null,
      loadingSuggestion: false,
      historicoDesvio: [],
      loadingHistoricoDesvio: false,
      exportLoading: false,
      exportDate: moment().format('YYYY-MM'),
    }
  },

  computed: {
    hasJQuery() {
      return typeof window !== 'undefined' && (Boolean(window.$) || Boolean(window.jQuery))
    },
    hasMapCoords() {
      if (!this.checkToMap) return false
      const lat = parseFloat(this.checkToMap.latitude)
      const lng = parseFloat(this.checkToMap.longitude)
      return !isNaN(lat) && !isNaN(lng)
    },
    isSuperAdmin() {
      return this.$store.state.user && Number(this.$store.state.user.is_admin) === 1
    },
    canMoveTurn() {
      const { user } = this.$store.state
      if (!user) return false
      return [1, 2].includes(Number(user.is_admin || 0))
    },
    canReviewDeviation() {
      const { user } = this.$store.state
      if (!user) return false
      return [1, 2].includes(Number(user.is_admin || 0))
    },
    years() {
      const list = []
      let y = parseInt(moment().year(), 10)
      for (; y >= 2019; y--) list.push(y)
      return list
    },
    months() {
      const thisYear = parseInt(moment().year(), 10)
      const last = this.search.year === thisYear ? parseInt(moment().month(), 10) + 1 : 12
      return Array.from({ length: last }, (_, i) => i + 1)
    },
    monthOptions() {
      return this.months.map(m => ({ value: m, label: this.monthNames[m - 1] }))
    },
    yearOptions() {
      return this.years.map(y => ({ value: y, label: String(y) }))
    },
    hasWorktime() {
      return Boolean(this.worktime)
    },
    worktimeLabel() {
      if (!this.worktime) return '-'
      if (this.worktime.title) return this.worktime.title
      if (this.worktime.hours !== undefined && this.worktime.hours !== null) {
        return `${this.worktime.hours}h`
      }
      return 'Jornada cadastrada'
    },

    /**
     * Número máximo de batidas em qualquer dia do período.
     * Mínimo de 2 para garantir pelo menos Entrada 1 / Saída 1.
     */
    maxPunches() {
      if (!this.checks || !this.checks.length) return 2
      const max = Math.max(...this.checks.map(c => (Array.isArray(c.punches) ? c.punches.length : 0)))
      return Math.max(max, 2)
    },
    hasPendingDeviationInResults() {
      if (!Array.isArray(this.checks) || this.checks.length === 0) return false
      return this.checks.some(check => this.hasPendingDeviationInCheck(check))
    },
  },

  mounted() {
    this.getLocation()
    this.getUsers()
    $('#modalMapa').on('shown.bs.modal', this.onMapaShown)
    $('#modalMapa').on('hidden.bs.modal', this.onMapaHidden)
  },
  beforeDestroy() {
    $('#modalMapa').off('shown.bs.modal', this.onMapaShown)
    $('#modalMapa').off('hidden.bs.modal', this.onMapaHidden)
  },

  methods: {

    hasScheduleDeviation(punch) {
      if (!punch || typeof punch !== 'object') return false
      return Number(punch.has_schedule_deviation) === 1
    },

    consideredHour(punch) {
      if (!punch || typeof punch !== 'object') return null
      const raw = punch.time_to_consider_f || punch.time_to_consider
      if (!raw) return null
      const m = moment(punch.time_to_consider || punch.time_to_consider_f, [
        'YYYY-MM-DD HH:mm:ss', 'DD/MM/YYYY HH:mm:ss', moment.ISO_8601,
      ])
      return m.isValid() ? m.format('HH:mm') : null
    },

    formatHistoryDate(value) {
      if (!value) return '—'
      const m = moment(value, ['YYYY-MM-DD HH:mm:ss', 'DD/MM/YYYY HH:mm:ss', moment.ISO_8601])
      return m.isValid() ? m.format('DD/MM/YYYY HH:mm') : String(value)
    },

    dayWorked(check) {
      const m = (check && check.meta) || {}
      return m.totalworkedformatted || m.total_worked_formatted || check?.total || '00:00:00'
    },
    dayExpected(check) {
      const m = (check && check.meta) || {}
      return m.expectedformatted || m.expected_formatted || '00:00:00'
    },
    dayUnauthorized(check) {
      const m = (check && check.meta) || {}
      return m.unauthorizedovertimeformatted || m.unauthorized_overtime_formatted || '00:00:00'
    },
    hasUnauthorized(check) {
      const m = (check && check.meta) || {}
      const ms = Number(m.unauthorizedovertimems ?? m.unauthorized_overtime_ms ?? 0)
      if (!Number.isNaN(ms) && ms > 0) return true
      const f = this.dayUnauthorized(check)
      return typeof f === 'string' && f.trim() !== '' && f.trim() !== '00:00:00'
    },

    hasPendingDeviationInCheck(check) {
      if (!check || !Array.isArray(check.punches)) return false
      return check.punches.some(punch => this.hasScheduleDeviation(punch))
    },

    isValidMobileCheck(check) {
      if (!check) return false
      const dm = check.date ? moment(check.date) : null
      const fp = Array.isArray(check.punches) ? check.punches[0] : null
      const pm = fp ? moment(fp.created_at || fp.datetime) : null
      return Boolean((dm && dm.isValid()) || (pm && pm.isValid()))
    },

    hasValidMobileChecks() {
      if (!Array.isArray(this.checks)) return false
      return this.checks.some(c => this.isValidMobileCheck(c) && Array.isArray(c.punches) && c.punches.length)
    },

    getDateForRow(check) {
      if (check && check.date) {
        const m = moment(check.date)
        if (m.isValid()) return m.format('DD/MM/YYYY')
      }
      const punches = Array.isArray(check?.punches) ? check.punches : this.normalizePoints(check)
      const first = punches && punches[0]
      if (!first) return '-'
      const m = moment(first.created_at || first.datetime)
      return m.isValid() ? m.format('DD/MM/YYYY') : '-'
    },

    getPunchColorClass(punch) {
      if (!punch) return null
      if (punch.check_request_id) return 'text-blue'
      if (punch.manual) return 'text-purple'
      if (punch.remote) return 'text-green'
      return null
    },

    isOutsideGeofence(punch) {
      if (!punch || typeof punch !== 'object') return false
      const raw = punch.outside_geofence !== undefined ? punch.outside_geofence : punch.geofenceoutside
      if (raw === undefined || raw === null || raw === '') return false
      if (typeof raw === 'boolean') return raw
      if (typeof raw === 'string') {
        const n = raw.trim().toLowerCase()
        if (['true', '1', 'sim', 'yes'].includes(n)) return true
        if (['false', '0', 'nao', 'não', 'no'].includes(n)) return false
      }
      return Number(raw) === 1
    },

    getGeofenceLabel(punch) {
      return this.isOutsideGeofence(punch) ? 'Fora da cerca' : 'Dentro da cerca'
    },

    hasInconsistency(punch) {
      if (!punch || typeof punch !== 'object') return false
      if (punch.check_request_id) return false
      if (Number(punch.manual) === 1) return false
      if (Number(punch.system_check) === 1) return false
      return this.isOutsideGeofence(punch) || !punch.check_face || Number(punch.check_face) === 0
    },

    formatHour(punch) {
      if (!punch) return '-'
      return moment(punch.created_at || punch.datetime).format('DD/MM/YYYY HH:mm:ss')
    },

    formatDate(date) {
      return moment(date).format('DD/MM/YYYY')
    },

    format(date) {
      return moment(date).format('DD/MM/YYYY HH:mm:ss')
    },

    formatSuggestion(val) {
      return val ? moment(val).format('DD/MM/YYYY HH:mm:ss') : ''
    },

    formatScheduleClock(val) {
      if (!val) return 'Não definido'
      const parsed = moment(val, ['HH:mm:ss', 'HH:mm'], true)
      if (parsed.isValid()) return parsed.format('HH:mm')
      if (typeof val === 'string') return val.slice(0, 5)
      return 'Não definido'
    },

    getDifferenceClass(diff) {
      if (!diff) return 'badge-secondary'
      if (diff === '00:00:00') return 'badge-primary'
      return diff.startsWith('-') ? 'badge-danger' : 'badge-success'
    },

    /**
     * Calcula o total de intervalos de descanso do dia.
     * Intervalo = tempo entre saída (índice ímpar) e próxima entrada (índice par seguinte).
     */
    calcRestInterval(check) {
      return check?.interval || null
    },

    /**
     * Calcula o total trabalhado somando todos os pares de batidas (entrada/saída).
     * Desconta automaticamente os intervalos de descanso.
     * Retorna string "HH:mm:ss" ou null se o dia estiver incompleto.
     */
    _calcTotalFromPunches(punches) {
      if (!punches || punches.length < 2 || punches.length % 2 !== 0) return null

      let totalSeconds = 0
      for (let i = 0; i < punches.length - 1; i += 2) {
        const entry = moment(punches[i].created_at || punches[i].datetime)
        const exit = moment(punches[i + 1].created_at || punches[i + 1].datetime)
        if (entry.isValid() && exit.isValid()) {
          const diff = exit.diff(entry, 'seconds')
          if (diff > 0) totalSeconds += diff
        }
      }

      if (totalSeconds <= 0) return null
      const h = Math.floor(totalSeconds / 3600)
      const m = Math.floor((totalSeconds % 3600) / 60)
      const s = totalSeconds % 60
      return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`
    },

    /**
     * Calcula diferença entre total trabalhado e jornada esperada (wku.hours).
     * Retorna string com sinal: "-01:30:00" (negativo) ou "00:30:00" (positivo).
     */
    _calcDiff(totalStr) {
      if (!totalStr) return null
      const parts = totalStr.split(':').map(Number)
      if (parts.length < 2) return null

      const workedSeconds = (parts[0] * 3600) + (parts[1] * 60) + (parts[2] || 0)
      const expectedSeconds = (this.wku?.hours || 8) * 3600
      const diffSec = workedSeconds - expectedSeconds

      const abs = Math.abs(diffSec)
      const h = Math.floor(abs / 3600)
      const m = Math.floor((abs % 3600) / 60)
      const s = abs % 60
      const str = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`
      return diffSec < 0 ? `-${str}` : str
    },

    normalizePoints(check) {
      if (!check) return []
      if (Array.isArray(check)) return check.filter(p => p && (p.created_at || p.datetime))
      if (typeof check === 'object') {
        return Object.keys(check)
          .filter(k => /^\d+$/.test(k))
          .sort((a, b) => Number(a) - Number(b))
          .map(k => check[k])
          .filter(p => p && (p.created_at || p.datetime))
      }
      return []
    },

    abrirModalMoverBatida(batida) {
      this.batidaParaMover = batida
      try {
        this.novaDataTurno = batida.shift_ref_date
          || (batida.created_at || batida.datetime
            ? moment(batida.created_at || batida.datetime).format('YYYY-MM-DD')
            : '')
      } catch (_) { this.novaDataTurno = '' }
      this.exibirModalMoverBatida = true
      this.$nextTick(() => {
        const jq = this._jq()
        if (jq && jq('#modalMoveTurn').length) {
          jq('#modalMoveTurn')
            .off('hidden.bs.modal')
            .on('hidden.bs.modal', () => {
              this.exibirModalMoverBatida = false
              this.batidaParaMover = null
              this.novaDataTurno = ''
            })
            .modal({ backdrop: 'static', keyboard: false })
            .modal('show')
        }
      })
    },

    fecharModalMoverBatida() {
      const jq = this._jq()
      if (jq && jq('#modalMoveTurn').length) jq('#modalMoveTurn').off('hidden.bs.modal').modal('hide')
      this.exibirModalMoverBatida = false
      this.batidaParaMover = null
      this.novaDataTurno = ''
    },

    async moverBatidaDeTurno() {
      if (!this.batidaParaMover?.id || !this.novaDataTurno) {
        this.$message('Erro', 'Selecione a nova data de turno.', 'error')
        return
      }
      try {
        await axios.post(
          `${this.$store.state.api}checks/${this.batidaParaMover.id}/move-turn`,
          { anchor_date: this.novaDataTurno, shift_ref_date: this.novaDataTurno },
        )
        this.$message('Sucesso', 'Batida movida com sucesso.', 'success')
        this.fecharModalMoverBatida()
        this.searchChecks()
      } catch (e) {
        this.$message('Erro', e?.response?.data?.message || 'Erro ao mover batida.', 'error')
      }
    },

    async abrirModalDesvio(punch) {
      this.batidaDesvio = punch
      this.acaoDesvio = null
      this.novoHorarioDesvio = moment(punch.created_at || punch.datetime).format('YYYY-MM-DDTHH:mm')
      this.justificativaDesvio = ''
      this.loadingDesvio = false
      this.suggestionDesvio = null
      this.loadingSuggestion = false
      this.historicoDesvio = []
      this.exibirModalDesvio = true

      this.$nextTick(() => {
        const jq = this._jq()
        if (jq && jq('#modalDesvio').length) {
          jq('#modalDesvio')
            .off('hidden.bs.modal')
            .on('hidden.bs.modal', () => this._resetDesvio())
            .modal({ backdrop: 'static', keyboard: false })
            .modal('show')
        }
      })

      this._fetchSuggestionDesvio(punch.id)
      this._fetchHistoricoDesvio(punch.id)
    },

    async _fetchHistoricoDesvio(checkId) {
      this.loadingHistoricoDesvio = true
      try {
        const { data } = await axios.get(`${this.$store.state.api}checks/${checkId}/deviation/history`)
        this.historicoDesvio = (data && data.status === '00' && Array.isArray(data.data)) ? data.data : []
      } catch (_) {
        this.historicoDesvio = []
      } finally {
        this.loadingHistoricoDesvio = false
      }
    },

    async _fetchSuggestionDesvio(checkId) {
      this.loadingSuggestion = true
      try {
        const { data } = await axios.get(`${this.$store.state.api}checks/${checkId}/deviation/suggestion`)
        if (data.status === '00') this.suggestionDesvio = data
      } catch (_) {
        this.suggestionDesvio = null
      } finally {
        this.loadingSuggestion = false
      }
    },

    fecharModalDesvio() {
      const jq = this._jq()
      if (jq && jq('#modalDesvio').length) jq('#modalDesvio').off('hidden.bs.modal').modal('hide')
      this._resetDesvio()
    },

    _resetDesvio() {
      this.exibirModalDesvio = false
      this.batidaDesvio = null
      this.acaoDesvio = null
      this.novoHorarioDesvio = ''
      this.justificativaDesvio = ''
      this.loadingDesvio = false
      this.suggestionDesvio = null
      this.loadingSuggestion = false
      this.historicoDesvio = []
      this.loadingHistoricoDesvio = false
    },

    async confirmarAcaoDesvio() {
      if (!this.acaoDesvio) return
      if (this.acaoDesvio === 'approve') {
        await this._aprovarDesvio()
      } else {
        await this._rejeitarDesvio()
      }
    },

    async _aprovarDesvio() {
      this.loadingDesvio = true
      try {
        await axios.post(`${this.$store.state.api}checks/${this.batidaDesvio.id}/deviation/approve`)
        this.$message('Sucesso', 'Desvio aprovado. Horário original mantido.', 'success')
        this.fecharModalDesvio()
        this.searchChecks()
      } catch (e) {
        this.$message('Erro', e?.response?.data?.message || 'Erro ao aprovar desvio.', 'error')
      } finally {
        this.loadingDesvio = false
      }
    },

    async _rejeitarDesvio() {
      if (!this.novoHorarioDesvio) {
        this.$message('Atenção', 'Informe o novo horário para o ajuste.', 'warning')
        return
      }
      if (!this.justificativaDesvio.trim()) {
        this.$message('Atenção', 'Informe a justificativa.', 'warning')
        return
      }

      const originalDate = moment(this.batidaDesvio.created_at || this.batidaDesvio.datetime).format('YYYY-MM-DD')
      const novoDate = moment(this.novoHorarioDesvio, 'YYYY-MM-DDTHH:mm').format('YYYY-MM-DD')

      if (originalDate !== novoDate) {
        const confirmed = await this.$confirm(
          `O novo horário (${novoDate}) é diferente do dia original (${originalDate}). Deseja continuar?`,
          'Atenção',
          { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' },
        ).catch(() => false)
        if (!confirmed) return
      }

      this.loadingDesvio = true
      try {
        const ajustado = moment(this.novoHorarioDesvio, 'YYYY-MM-DDTHH:mm').format('YYYY-MM-DD HH:mm:ss')
        await axios.post(`${this.$store.state.api}checks/${this.batidaDesvio.id}/deviation/reject`, {
          adjusted_punched_at: ajustado,
          justification: this.justificativaDesvio.trim(),
        })
        this.$message('Sucesso', 'Horário corrigido e desvio registrado.', 'success')
        this.fecharModalDesvio()
        this.searchChecks()
      } catch (e) {
        this.$message('Erro', e?.response?.data?.message || 'Erro ao corrigir batida.', 'error')
      } finally {
        this.loadingDesvio = false
      }
    },

    mapClicked(event) {
      this.markerPosition = { lat: event.latLng.lat(), lng: event.latLng.lng() }
      this.latitude = event.latLng.lat()
      this.longitude = event.latLng.lng()
    },

    markerDragged(event) {
      this.markerPosition = { lat: event.latLng.lat(), lng: event.latLng.lng() }
      this.latitude = event.latLng.lat()
      this.longitude = event.latLng.lng()
    },

    geocodeLatLng(lat, lng) {
      const geocoder = new google.maps.Geocoder()
      this.isLoading = true
      geocoder.geocode({ location: { lat: parseFloat(lat), lng: parseFloat(lng) } })
        .then(r => { this.formatted_address = r.results[0]?.formatted_address || 'Nenhum resultado' })
        .catch(() => { this.formatted_address = 'Erro ao buscar endereço' })
        .finally(() => { this.isLoading = false })
    },

    openImage(url) {
      if (url) window.open(url, '_blank')
    },

    openMapaModal(check) {
      this.checkToMap = check
      const lat = parseFloat(check.latitude)
      const lng = parseFloat(check.longitude)
      if (isNaN(lat) || isNaN(lng)) {
        this.formatted_address = 'Sem latitude e longitude'
        $('#modalMapa').modal('show')
        return
      }
      this.center = { lat, lng }
      this.markerPosition = { lat, lng }
      this.geocodeLatLng(lat, lng)
      $('#modalMapa').modal('show')
    },

    onMapaShown() {
      if (this.hasMapCoords) this.renderCheckMap()
    },

    onMapaHidden() {
      this.checkMap = null
      this.checkMarker = null
      this.checkToMap = null
    },

    renderCheckMap() {
      const el = this.$refs.mapEl
      if (!el || !window.google || !window.google.maps) return

      if (!this.checkMap) {
        this.checkMap = new window.google.maps.Map(el, {
          center: this.center,
          zoom: 16,
          streetViewControl: false,
          mapTypeControl: false,
          fullscreenControl: false,
        })
      } else {
        this.checkMap.setCenter(this.center)
      }

      if (!this.checkMarker) {
        this.checkMarker = new window.google.maps.Marker({ map: this.checkMap, position: this.center })
      } else {
        this.checkMarker.setPosition(this.center)
      }

      this.$nextTick(() => {
        window.google.maps.event.trigger(this.checkMap, 'resize')
        this.checkMap.setCenter(this.center)
      })
    },

    confirmMapCheck() {
      if (this.checkToMap?.id) {
        this.MapCheck(this.checkToMap.id)
        $('#modalMapa').modal('hide')
        this.searchChecks()
        this.checkToMap = null
      }
    },

    MapCheck(id) {
      // Campo de justificativa (obrigatório) dentro do swal — lemos o valor direto
      // do elemento para não depender da resolução input × valor-do-botão do sweetalert.
      const input = document.createElement('input')
      input.type = 'text'
      input.maxLength = 255
      input.placeholder = 'Motivo da exclusão (obrigatório)'
      input.className = 'form-control'

      swal({
        title: 'Excluir esta batida?',
        text: 'Esta ação NÃO pode ser desfeita. Informe a justificativa da exclusão:',
        icon: 'warning',
        content: input,
        buttons: ['Cancelar', 'Excluir'],
        dangerMode: true,
      }).then(confirmed => {
        if (!confirmed) { swal('Cancelado', 'A batida não foi excluída', 'info'); return }

        const justification = (input.value || '').trim()
        if (justification.length < 3) {
          swal('Justificativa obrigatória', 'Descreva o motivo da exclusão (mín. 3 caracteres).', 'error')
          return
        }

        this.loading = true
        axios.delete(`${this.$store.state.api}checks/${id}`, { data: { justification } })
          .then(() => {
            this.$message('Sucesso', 'Batida excluída com sucesso', 'success')
            this.checkToMap = null
            $('#modalMapa').modal('hide')
            this.searchChecks()
          })
          .catch(e => { this.$message(null, e.response.data, 'error') })
          .finally(() => { this.loading = false })
      })
    },

    searchChecks() {
      const { user_id, year, month } = this.search
      if (!user_id || !year || !month) return

      this.hasSearched = true
      const monthParam = month - 1

      axios.get(`${this.$store.state.api}checks/myChecks`, {
        params: { year, month: monthParam, user_id },
      })
        .then(response => {
          const organized = response.data.organizedChecks || {}
          const organizedTimeline = response.data.organizedChecksTimeline || {}
          this.worktime = response.data.worktime?.worktime || null
          this.wku = this.worktime || { hours: 8 }

          this.checks = Object.entries(organized).map(([dateKey, dayData]) => {
            const punches = Object.keys(dayData)
              .filter(k => /^\d+$/.test(k))
              .sort((a, b) => Number(a) - Number(b))
              .map(k => dayData[k])
              .filter(p => p && (p.created_at || p.datetime))

            const meta = dayData.meta || {}

            const interval = meta.interval || null
            const total = meta.totalworkedformatted || meta.total_worked_formatted || null
            const diff = meta.diffformatted || meta.diff_formatted || meta.diffformattedraw || meta.diff_formatted_raw || null

            return {
              date: dateKey, punches, total, diff, interval, meta,
            }
          })

          // Desativado temporariamente: point-mirror/dashboard.
          // Preenche this.bank/this.loaded, que hoje não são usados na tela.
          // this.getEntity(user_id);
        })
        .catch(e => {
          this.worktime = null
          this.$message('Erro', e?.response?.data?.message || 'Erro ao buscar marcações.', 'error')
        })
    },

    exportChecks() {
      this.exportLoading = true
      axios.get(`${this.$store.state.api}checks/export`, {
        params: { date: this.exportDate, user_id: this.search.user_id || null },
        responseType: 'blob',
      })
        .then(response => {
          const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `checks_${this.exportDate}.csv`)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
        })
        .catch(e => {
          this.$message('Erro', e.response?.data || 'Erro ao exportar', 'error')
        })
        .finally(() => { this.exportLoading = false })
    },

    getUsers() {
      axios.get(`${this.$store.state.api}users/active`)
        .then(r => { this.users = r.data })
        .catch(e => { this.$message('Erro', e.response.data, 'error') })
    },

    getEntity(userId) {
      axios.post(`${this.$store.state.api}point-mirror/dashboard`, { user_id: userId })
        .then(r => { this.bank = r.data; this.loaded = true })
        .catch(e => { this.errors = e.response.data; this.$message(null, this.errors, 'error') })
    },

    getLocation() {
      if (!navigator.geolocation) { this.error = 'Geolocalização não suportada pelo navegador.'; return }
      navigator.geolocation.getCurrentPosition(
        pos => {
          this.location = { latitude: pos.coords.latitude, longitude: pos.coords.longitude }
          this.markerPosition = { lat: pos.coords.latitude, lng: pos.coords.longitude }
          this.latitude = pos.coords.latitude
          this.longitude = pos.coords.longitude
          this.center = { lat: pos.coords.latitude, lng: pos.coords.longitude }
          this.error = null
        },
        err => {
          const msgs = {
            [err.PERMISSION_DENIED]: 'Usuário negou a solicitação de Geolocalização.',
            [err.POSITION_UNAVAILABLE]: 'A localização não está disponível.',
            [err.TIMEOUT]: 'A solicitação de localização expirou.',
          }
          this.error = msgs[err.code] || 'Um erro desconhecido ocorreu.'
        },
      )
    },

    _jq() {
      return typeof window !== 'undefined' && (window.$ || window.jQuery)
        ? (window.$ || window.jQuery)
        : null
    },
  },
}
</script>

<style scoped>
@media (max-width: 575.98px) {
  .card-title { font-size: 1.1rem; }
  .mb-3 { margin-bottom: 1rem !important; }
}
@media (max-width: 767.98px) {
  .highlight .col-12 { margin-bottom: 0.75rem; }
}
.text-blue   { color: #007bff !important; }
.text-green  { color: #28a745 !important; }
.text-purple { color: #6f42c1 !important; }
.text-orange { color: #fd7e14 !important; }
.legend-bar  { gap: 1rem; }
.legend-item { font-size: 0.9rem; color: #6c757d; display: inline-flex; align-items: center; gap: 0.4rem; }
.pending-diff-notice {
  border: 1px solid #f6a609;
  background: #fff8e8;
  color: #8a5800;
}
.considered-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  font-size: 0.7rem;
  line-height: 1;
  padding: 0.12rem 0.4rem;
  border-radius: 0.6rem;
  border: 1px solid #d6d8db;
  background: #f1f3f5;
  color: #6c757d;
  white-space: nowrap;
}
.considered-badge .fa-clock { font-size: 0.65rem; }
.result-cell { display: flex; flex-direction: column; gap: 0.15rem; font-size: 0.8rem; }
.result-row  { display: flex; justify-content: space-between; gap: 0.75rem; }
.result-label { color: #000000; font-size: 0.9rem; }
.result-value { font-weight: 600; color: #343a40; white-space: nowrap; font-size: 0.865rem; }
.result-row.result-na-pending .result-label,
.result-row.result-na-pending .result-value { color: #8a5800; }
.result-row.result-saldo { border-top: 1px dashed #e3e6f0; padding-top: 0.15rem; margin-top: 0.1rem; }
.considered-badge.considered-pending {
  border-color: #f6a609;
  background: #fff8e8;
  color: #8a5800;
  font-weight: 600;
}

.dark-layout .result-label {
  color: #ffffff;
  font-size: 0.9rem;
}

.dark-layout .result-value {
  color: #ffffff;
  font-size: 0.9rem;
}

@media (max-width: 767.98px) {
  .legend-bar  { gap: 0.5rem; }
  .legend-item { font-size: 0.85rem; }
}
.legend-dot    { width: 12px; height: 12px; border-radius: 50%; display: inline-block; }
.legend-blue   { background-color: #007bff; }
.legend-green  { background-color: #28a745; }
.legend-purple { background-color: #6f42c1; }
.legend-orange { background-color: #fd7e14; }
.check-map-container { width: 100%; height: 340px; border-radius: 6px; background: #e9ecef; }
@media (max-width: 767.98px) {
  .check-map-container { height: 240px; }
}
.check-card       { transition: all 0.3s ease; border: 1px solid #e3e6f0; box-shadow: 0 0.15rem 1.75rem 0 rgba(58,59,69,.15); }
.check-card:hover { transform: translateY(-3px); box-shadow: 0 0.5rem 2rem 0 rgba(58,59,69,.2); }
.check-card .card-header { background: linear-gradient(45deg, #f8f9fc, #eaecf4); border-bottom: 1px solid #e3e6f0; }
.check-card .card-title  { color: #5a5c69; font-weight: 600; }
.btn-pin    { padding: 0.15rem 0.4rem; font-size: 0.75rem; line-height: 1; border-radius: 0.25rem; }
.time-text  { font-weight: 500; font-size: 0.875rem; }
.time-info  { min-width: 140px; text-align: left; }
.table-container-scroll { max-height: 300px; overflow-y: auto; border: 1px solid #dee2e6; border-radius: 0.375rem; margin-top: 1rem; }
.table-container-scroll::-webkit-scrollbar       { width: 8px; }
.table-container-scroll::-webkit-scrollbar-track { background: #f8f9fa; border-radius: 4px; }
.table-container-scroll::-webkit-scrollbar-thumb { background: #6c757d; border-radius: 4px; }
.table-container-scroll::-webkit-scrollbar-thumb:hover { background: #495057; }
.table-container-scroll .table { margin-bottom: 0; }
.table-container-scroll .thead-light th { position: sticky; top: 0; background-color: #f8f9fa; z-index: 10; border-bottom: 2px solid #dee2e6; }
.table td      { vertical-align: middle; padding: 0.75rem 0.5rem; }
.table .btn-sm { padding: 0.25rem 0.5rem; font-size: 0.75rem; min-width: 32px; height: 28px; }
.badge           { font-size: 0.75rem; padding: 0.375rem 0.5rem; }
.badge-success   { background-color: #28a745 !important; color: #fff !important; }
.badge-danger    { background-color: #dc3545 !important; color: #fff !important; }
.badge-primary   { background-color: #007bff; }
.badge-secondary { background-color: #6c757d; }
.alert-info      { background-color: #d1ecf1; border-color: #bee5eb; color: #0c5460; }
.d-flex.align-items-center { gap: 0.5rem; }
.pin-button  { margin-left: 0.25rem !important; padding: 0.25rem 0.5rem; font-size: 0.75rem; min-width: 32px; height: 28px; }
.card-body .row   { align-items: center; }
.card-body .col-5 { display: flex; align-items: center; min-height: 32px; }
.card-body .col-7 { display: flex; align-items: center; min-height: 32px; }
.map-container  { width: 100%; height: 400px; position: relative; overflow: hidden; border-radius: 0.375rem; border: 1px solid #dee2e6; }
.responsive-map { width: 100% !important; height: 100% !important; }
.modal-responsive { max-width: 90vw; width: auto; }
@media (max-width: 767.98px) {
  .modal-responsive { max-width: 95vw; margin: 0.5rem; }
  .map-container    { height: 300px; }
  .modal-title      { font-size: 0.9rem; }
  .modal-header     { padding: 0.75rem; }
  .modal-footer     { padding: 0.75rem; }
}
@media (max-width: 575.98px) {
  .modal-dialog     { margin: 0.5rem; }
  .modal-body       { padding: 1rem 0.75rem; }
  .modal-responsive { max-width: 98vw; margin: 0.25rem; }
  .map-container    { height: 250px; }
}
@media (max-width: 360px) {
  .modal-responsive { max-width: 100vw; }
  .modal-dialog     { margin: 0; }
  .modal-content    { border-radius: 0; height: 100vh; overflow-y: auto; }
  .map-container    { height: 200px; }
}
#modalMoveTurn        { cursor: default; }
#modalMoveTurn .btn,
#modalMoveTurn button { cursor: pointer; }
</style>
